// src/services/profileService.js
// Service pour les appels API profil

import api from './api';

const profileService = {
  /**
   * Mettre à jour les informations personnelles
   * PUT /api/auth/profile
   */
  async updateProfile(data) {
    try {
      const response = await api.put('/auth/profile', {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        address: data.address,
        city: data.city,
        country: data.country
      });

      // Mettre à jour le localStorage
      if (response.data.user) {
        const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
        const updatedUser = { ...currentUser, ...response.data.user };
        localStorage.setItem('user', JSON.stringify(updatedUser));
      }

      return {
        success: true,
        data: response.data.user,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erreur mise à jour profil:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la mise à jour'
      };
    }
  },

  /**
   * Changer le mot de passe
   * PUT /api/auth/change-password
   */
  async changePassword(currentSecretCode, newSecretCode) {
    try {
      const response = await api.put('/auth/change-password', {
        currentSecretCode,
        newSecretCode,
      });

      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erreur changement mot de passe:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du changement de code secret'
      };
    }
  },

  /**
   * Obtenir les statistiques du compte
   * GET /api/profile/stats
   */
  async getAccountStats() {
    try {
      const response = await api.get('/profile/stats');
      return {
        success: true,
        stats: response.data.stats
      };
    } catch (error) {
      console.error('Erreur récupération stats:', error);
      return {
        success: false,
        stats: {}
      };
    }
  },

  /**
   * Vérifier si le compte peut être supprimé
   * GET /api/profile/can-delete
   */
  async canDeleteAccount() {
    try {
      const response = await api.get('/profile/can-delete');
      return {
        success: true,
        canDelete: response.data.canDelete,
        reason: response.data.reason
      };
    } catch (error) {
      console.error('Erreur vérification suppression:', error);
      return {
        success: false,
        canDelete: false,
        reason: 'Erreur de connexion'
      };
    }
  },

  /**
   * Désactiver le compte (temporaire)
   * PUT /api/profile/deactivate
   */
  async deactivateAccount(secretCode) {
    try {
      const response = await api.put('/profile/deactivate', { secretCode });
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erreur désactivation compte:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la désactivation'
      };
    }
  },

  /**
   * Supprimer le compte définitivement
   * DELETE /api/profile/delete
   */
  async deleteAccount(secretCode, confirmation) {
    try {
      const response = await api.delete('/profile/delete', {
        data: { secretCode, confirmation }
      });
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erreur suppression compte:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression'
      };
    }
  }
};

export default profileService;